import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

import { AreaPageElementRatingGroupModel, TemplateEditorRatingGroupItem } from '@template/models/template-editor-model';

@UntilDestroy()
@Component({
  selector: 'app-template-editor-rating-group',
  templateUrl: './rating-group.component.html',
  styleUrls: ['./rating-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingGroupComponent {
  @Input() ratingGroup: AreaPageElementRatingGroupModel;

  @Output() ratingGroupChange = new EventEmitter<AreaPageElementRatingGroupModel>();

  makeDefault(item: TemplateEditorRatingGroupItem) {
    this.ratingGroupChange.emit({
      ...this.ratingGroup,
      items: this.ratingGroup.items.map(ratingItem => ({
        item: { ...ratingItem.item, isDefault: ratingItem.item.id === item.item.id },
      })),
    });
  }

  onRatingItemChange(item: TemplateEditorRatingGroupItem) {
    this.ratingGroupChange.emit({
      ...this.ratingGroup,
      items: this.ratingGroup.items.map(ratingItem => {
        if (ratingItem.item.id === item.item.id) {
          return item;
        } else {
          return ratingItem;
        }
      }),
    });
  }

  trackBy(_index: number, item: TemplateEditorRatingGroupItem) {
    return item.item.id;
  }
}
